export default {
  name: "EventTableActionMenu",
  props: [
    "item",
    "editHelper",
    "deleteHelper",
    "copyHelper",
    "checkBoxActiveHelper",
    "checkBoxCancelledHelper",
    "checkBoxMomentCancelledHelper"
  ],
  data: () => ({
    hover: false
  }),
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    isOwnedBySubPrincipal() {
      if (!this.item.principal_id?.length) {
        return false;
      }
      return this.item.principal_id !== this.currentPrincipal?.id;
    }
  }
};
